import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Stack,
  Typography,
  Menu,
  Card,
  CardContent,
  IconButton,
  styled,
  InputBase,
  Radio,
  FormControlLabel,
  Badge,
  Select,
  FormControl,
  Tooltip,
  Divider,
  Skeleton,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import SearchIcon from "@mui/icons-material/Search";
import { PlusOutlined } from "@ant-design/icons";
import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import { getImages } from "../../commonComponents/const";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import NorthOutlinedIcon from "@mui/icons-material/NorthOutlined";
import SouthOutlinedIcon from "@mui/icons-material/SouthOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useFetchSolutionProviderRequirementBoardQuery } from "../../redux/api/SolutionProvider/getBsiCoLabSolutionList";
import { useDispatch, useSelector } from "react-redux";
import { getBoardDetail } from "../../redux/features/kanbanSlice";
import { toast, ToastContainer } from "react-toastify";
import CustomLoader from "../../utils/Loader/CustomLoader";
import { hideLoader, showLoader } from "../../redux/features/loader";
import { getBoardId, getBoardName } from "../../redux/features/boardSlice";
import CancelIcon from "@mui/icons-material/Cancel";
import NoDataPage from "../../utils/Error/noDataFound";
import { resetRefetchRequirementBoard } from "../../redux/features/refetch";
import Modals from "../../commonComponents/Modals";
import BoardSetting from "../../commonComponents/Kanban/BoardSetting";
import DeleteBoardAlert from "../../commonComponents/Kanban/DeleteBoardAlert";
import NoDataScreen from "../../commonComponents/noData";
import BsiCoLabSkull from "../../commonComponents/BsiCoLab/bsiCoLabSkull";
import useBreakpoint from "../../commonComponents/ResponsiveBreakPoints";
import LimitExceededModal from "../../commonComponents/LimitExceededModal";
import SubscribeModal from "../../commonComponents/SubscribeModal";
import PaymentSuccess from "../MySubscription/paymentSuccess";
import NoSolutionScreen from "../../commonComponents/NoDataScreens/noSolutionScreen";
import UpgradeModal from "../../commonComponents/upgradeModal";
import { useFetchIndustryListQuery } from "../../redux/api/Users";

const SolutionProviderBsiCoLab = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDrawerOpen = useSelector((state) => state.drawer.open);
  const planName = useSelector((state) => state.user.planName);
  const s3Url = process.env.REACT_APP_S3_BUCKET_URL;
  const limitMessage = `Your current plan only support limited solution submission. Please upgrade to higher plan to add more solutions`;
  const { breakpoint} = useBreakpoint();

    // Define skull count based on breakpoints
    const getSkullCount = (breakpoint) => {
      switch (breakpoint) {
        case 'xl':
          return 8; // e.g., 10 skulls for extra-large screens
        case 'lg':
          return 6; // e.g., 8 skulls for large screens
        case 'md':
          return 4; // e.g., 6 skulls for medium screens
        case 'sm':
          return 2; // e.g., 4 skulls for small screens
        case 'xs':
        default:
          return 2; // e.g., 2 skulls for extra-small screens
      }
    };
    const skullCount = getSkullCount(breakpoint);

  // toast messages
  const showToastMessage = (message, type) => {
    if (type === "success") {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (type === "info") {
      toast.warning(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  // Search Box
  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#ECF6FF",
    "&:hover": {
      backgroundColor: "#ECF6FF",
    },
    marginRight: "0",
    marginLeft: 0,
    marginBottom: 5,
    width: "100%",
    display: "flex",
    alignItems: "center",
  }));
  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    right: "0",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "#106EED",
    width: "100%",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1.7, 0, 1.7, 1.7),
      paddingRight: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      fontSize: "12px",
      fontWeight: "500",
    },
  }));

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 24,
    height: 24,
    border: `2px solid ${theme.palette.background.paper}`,
  }));

  const [openSort, setOpenSort] = useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [anchorElSort, setAnchorElSort] = useState(null);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [sortOption, setSortOption] = useState("asc");
  const [industry, setIndustry] = useState("");
  const [tech, setTech] = useState("");
  const [techValue, setTechValue] = useState("");
  const [industryFilterId, setIndustryFilterId] = useState("");
  const [searchParams, setSearchParams] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [boardId, setBoardId] = useState("");
  const [boardName, setBoardName] = useState("");
  // getting userId from localStorage
  const location = useLocation();
  const userId = localStorage.getItem("userId");
  // apiCall
  const {
    data: boardData,
    error: boardError,
    isLoading: boardLoading,
    refetch,
  } = useFetchSolutionProviderRequirementBoardQuery({
    // user_id: userId,
    sort: sortOption,
    solution_name: searchValue,
  });


    // Function to get initials
    const getInitials = (name) => {
      const namesArray = name.split(" ");
      const firstInitial = namesArray[0]?.charAt(0).toUpperCase();
      const secondInitial = namesArray[1] ? namesArray[1].charAt(0).toUpperCase() : "";
      return firstInitial + secondInitial;
    };

  // set refetchKanban in reduxStore
  const refetchRequirementBoard = useSelector(
    (state) => state.refetch.refetchRequirementBoard
  );
  useEffect(() => {
    if (refetchRequirementBoard) {
      refetch().finally(() => {
        dispatch(resetRefetchRequirementBoard());
      });
    }
  }, [refetchRequirementBoard, refetch, dispatch]);
  const {
    data: IndustryData,
    isLoading: industryLoading,
    error: industryError,
  } = useFetchIndustryListQuery();
  const handleClickSort = (event) => {
    setAnchorElSort(event.currentTarget);
    setOpenSort(!openSort);
  };
  const handleCloseSort = (event) => {
    setAnchorElSort(null);
    setOpenSort(false);
    setSelectedSortOption(event.target.value);
  };
  const handleSorting = (event) => {
    setSortOption(event.target.value);
    setOpenSort(false);
  };

  const handleIndustry = (event) => {
    setIndustry(event.target.value);
  };
  const handleTech = (event) => {
    setTech(event.target.value);
  };

  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilter(!openFilter);
  };
  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilter(false);
  };
  const handleFilter = () => {
    setIndustryFilterId(industry);
    setTechValue(tech);
    setOpenFilter(false);
  };
  const handleFilterClear = () => {
    setIndustry("");
    setTech("");
    setIndustryFilterId("");
    setTechValue("");
    setOpenFilter(false);
  };
  // board setting
  // list1Settings Modal
  const [openBoardSettings, setOpenBoardSettings] = useState(false);
  const boardSettingsHandle = (boardId, boardName) => {
    setOpenBoardSettings(true);
    setBoardId(boardId);
    setBoardName(boardName);
  };
  const closeBoardSettings = () => {
    setOpenBoardSettings(false);
  };
  // Delete list1Alert Modal
  const [openDeleteBoardAlert, setOpenDeleteBoardAlert] = useState(false);
  const deleteBoardAlertHandle = () => {
    setOpenDeleteBoardAlert(true);
    setOpenBoardSettings(false);
  };
  const closeDeleteBoardAlert = () => {
    setOpenDeleteBoardAlert(false);
  };
  const goBackFromAlertHandle = () => {
    setOpenDeleteBoardAlert(false);
    setOpenBoardSettings(true);
  };

  useEffect(() => {
    if (boardLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [boardLoading, dispatch]);

  // Searching logic
  const handleInputChange = (event) => {
    setSearchParams(event.target.value.trim());
  };

  const handleRequirementBoardSearch = async (event) => {
    if (event.key === "Enter") {
      const inputValue = event.target.value.trim();
      if (!inputValue) {
        setSearchValue(""); // Reset the searchValue state
        await refetch();
        return;
      }

      setSearchValue(inputValue);
      dispatch(showLoader());
      try {
        await refetch();
        if (boardError) {
          const errorMessage = boardData?.message || "No Data Found";
          showToastMessage(errorMessage, "error");
          return;
        }

      } catch (boardError) {
        showToastMessage("An error occurred during search", "error");
      } finally {
        // Hide loader after refetch is complete
        dispatch(hideLoader());
      }
    }
  };
  const handleClearSearch = () => {
    setSearchParams("");
    setSearchValue(""); 
    refetch(); 
  };

  const handleCardClick = (solutionId, solutionName, industry) => {
    localStorage.setItem("solutionId", solutionId);
    localStorage.setItem("solutionName", solutionName);
    localStorage.setItem("industry", industry);
    navigate("/bsi-co-lab/kanban");
  };
  const handleViewRequirementClick = (boardId, boardName) => {
    navigate(
      `/bsi-co-lab-requirements?boardId=${encodeURIComponent(
        boardId
      )}&boardName=${encodeURIComponent(boardName)}`
    );
  };
 
  if (boardLoading) {
    dispatch(showLoader());
  } else {
    dispatch(hideLoader());
  }

  const truncateText = (text) => {
    const minLength = 100
    if (!text || text.length <= minLength) {
      return text;
    }
    return `${text.substring(0, minLength)}...`;
  };

      // limitExceeed modal
      const [openUpgradeModal , setOpenUpgradeModal] = useState(false);
      const handleOpenUpgradeModal = ()=>{
        setOpenUpgradeModal(true);
      }
      const handleCloseUpgradeModal = ()=>{
        setOpenUpgradeModal(false);
      }
       // Subscribe modal
       const [openSubscribeModal , setOpenSubscribeModal] = useState(false);
       const handleOpenSubscribeModal = ()=>{
        setOpenSubscribeModal(true);
       }
       const handleCloseSubscribeModal = ()=>{
        setOpenSubscribeModal(false);
       }

       //  PaymentSuccess Modal
     const [openPaymentSuccess , setOpenPaymentSuccess] = useState(false)

     const handleOpenPaymentSuccessModal = ()=>{
       setOpenPaymentSuccess(true);
     }
     const handleClosePaymentSuccessModal = ()=>{
       setOpenPaymentSuccess(false);
     } 
  
      // useEffect(()=>{
      //   if(planName === "Lite"){
      //     setOpenSubscribeModal(true);
      //   }
      // },[])

  return (
    <>
      <Grid container rowSpacing={{ md: 4.5, xs: 1 }} columnSpacing={2.75}>
        <Grid item lg={6} md={6} sm={4} xs={12}>
            {/* <Button
              variant="contained"
              sx={{
                textTransform: "inherit",
                p: "10px 25px",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
                [theme.breakpoints.down("md")]: {
                  p: "11px 12px",
                },
                [theme.breakpoints.down("sm")]: {
                  p: "10px 25px",
                },
                [theme.breakpoints.down("xs")]: {
                  p: "10px 25px",
                },
              }}
            >
              <PlusOutlined
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "1px",
                  marginTop: "4px",
                }}
              />
              Create Solution Requirement
            </Button> */}
        </Grid>
        <Grid item xs={12} md={6} lg={6} sm={8}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              [theme.breakpoints.down("sm")]: {
                flexWrap: "wrap",
                width: "100%",
              },
            }}
          >
            <Box
              sx={{
                mr: 2,
                width: "45%",
                [theme.breakpoints.down("sm")]: {
                  width: "100%",
                  mr: 0,
                },
              }}
            >
              <Search>
                <StyledInputBase
                  placeholder="Search Solutions"
                  inputProps={{ "aria-label": "search" }}
                  value={searchParams}
                  onChange={handleInputChange}
                  onKeyDown={handleRequirementBoardSearch}
                  autoFocus
                />
                {searchParams ? (
                  <IconButton
                    onClick={handleClearSearch}
                    sx={{ position: "absolute", right: 0 }}
                  >
                    <CancelIcon sx={{ color: "lightSecondary.main" }} />
                  </IconButton>
                ) : (
                  <SearchIconWrapper>
                    <SearchIcon sx={{ color: "lightSecondary.main" }} />
                  </SearchIconWrapper>
                )}
              </Search>
            </Box>
            <Box
              sx={{
                // mr: 1,
                [theme.breakpoints.down("sm")]: {
                  width: "100%",
                  // mr: 1,
                },
              }}
            >
              <Button
                id="basic-button"
                aria-controls={openSort ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openSort ? "true" : undefined}
                onClick={handleClickSort}
                sx={{
                  background: "#fff",
                  fontSize: "0.9rem",
                  color: "lightSecondary.main",
                  textTransform: "inherit",
                  fontWeight: "600",
                  p: "10px 20px",
                  [theme.breakpoints.down("sm")]: {
                    width: "100%",
                  },
                }}
              >
                Sort
                <KeyboardArrowDownOutlined sx={{}} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorElSort}
                open={openSort}
                onClose={handleCloseSort}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{
                  "& .MuiMenu-paper": {
                    borderRadius: "10px",
                    border: "solid 1px #106EED",
                  },
                }}
              >
                {/* <MenuItem
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: "0.9rem",
                                            color: "#2A589C",
                                            fontWeight: "600",
                                        }
                                    }}
                                    onClick={()=>{handleCloseSort ; handleSorting() }}>
                                    <FormControlLabel
                                        value="CreatedUp" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedUp'} />} label="Created" />
                                    <NorthOutlinedIcon sx={{
                                        fontSize: "1.1rem",
                                        color: "#2A589C"
                                    }} />
                                </MenuItem>
                                <MenuItem
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: "0.9rem",
                                            color: "#2A589C",
                                            fontWeight: "600",
                                        }
                                    }}
                                    onClick={handleCloseSort}>
                                    <FormControlLabel
                                        value="CreatedDown" control={<Radio sx={{ paddingY: 0, color: "#2A589C" }} checked={selectedSortOption === 'CreatedDown'} />} label="Created" />
                                    <SouthOutlinedIcon sx={{
                                        fontSize: "1.1rem",
                                        color: "#2A589C"
                                    }} />
                                </MenuItem> */}
                <MenuItem
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    "& .MuiFormControlLabel-root": {
                      width: "100%", // Make the FormControlLabel take the full width
                      height: "100%",
                    },
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.9rem",
                      color: "#2A589C",
                      fontWeight: "600",
                    },
                  }}
                  onClick={handleSorting}
                >
                  <FormControlLabel
                    value="asc"
                    sx={{ width: "100%", height: "100%" }}
                    control={
                      <Radio
                        sx={{
                          paddingY: 0,
                          color: "#2A589C",
                          width: "100%",
                          height: "100%",
                        }}
                        checked={sortOption === "asc"}
                      />
                    }
                    label="Name A-Z"
                  />
                </MenuItem>
                <MenuItem
                  sx={{
                    "& .MuiFormControlLabel-root": {
                      width: "100%",
                      height: "100%", // Make the FormControlLabel take the full width
                    },
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.9rem",
                      color: "#2A589C",
                      fontWeight: "600",
                    },
                  }}
                  onClick={handleSorting}
                >
                  <FormControlLabel
                    value="dsc"
                    control={
                      <Radio
                        sx={{ paddingY: 0, color: "#2A589C" }}
                        checked={sortOption === "dsc"}
                      />
                    }
                    label="Name Z-A"
                  />
                </MenuItem>
              </Menu>
            </Box>
            <Box
              sx={{
                [theme.breakpoints.down("sm")]: {
                  width: "50%",
                },
              }}
            >
              {/* <Button
                id="basic-button"
                aria-controls={openFilter ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openFilter ? "true" : undefined}
                onClick={handleClickFilter}
                sx={{
                  background: "#fff",
                  fontSize: "0.9rem",
                  color: "lightSecondary.main",
                  textTransform: "inherit",
                  fontWeight: "600",
                  p: "10px 20px",
                  [theme.breakpoints.down("sm")]: {
                    width: "100%",
                  },
                }}
              >
                Filter
                <KeyboardArrowDownOutlined />
              </Button> */}
              {/* <Menu
                id="basic-menu"
                anchorEl={anchorElFilter}
                open={openFilter}
                onClose={handleCloseFilter}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{
                  "& .MuiMenu-paper": {
                    borderRadius: "10px",
                    border: "solid 1px #106EED",
                    minWidth: "280px",
                    px: 2.3,
                    py: 1,
                  },
                }}
              >
                <Box
                  sx={{
                    mb: 1.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "ltheme.main",
                      lineHeight: "24px",
                    }}
                    variant="body2"
                  >
                    Select Industry
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  >
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={industry}
                      onChange={handleIndustry}
                      displayEmpty
                      IconComponent={KeyboardArrowDownOutlinedIcon}
                      sx={{
                        background: "#ECF6FF",
                        "& .MuiSelect-select": {
                          minHeight: "20px",
                          padding: "11px 14px",
                          color: "lightSecondary.main",
                          fontWeight: "600",
                          fontSize: "0.9rem",
                        },
                        "& .MuiSelect-icon": {
                          color: "lightSecondary.main",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: "240px",
                            overflowY: "auto",
                            "&::-webkit-scrollbar": {
                              width: "6px",
                              borderRadius: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "transparent",
                              borderRadius: "4px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#9C9C9C",
                              borderRadius: "4px",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Industry
                      </MenuItem>
                      {Array.isArray(IndustryData?.data) &&
                        IndustryData.data.length > 0 &&
                        IndustryData.data.map((industry) => (
                          <MenuItem key={industry._id} value={industry._id}>
                            {industry.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "ltheme.main",
                      lineHeight: "24px",
                    }}
                    variant="body2"
                  >
                    Select Tech
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    }}
                  >
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={tech}
                      onChange={handleTech}
                      displayEmpty
                      IconComponent={KeyboardArrowDownOutlinedIcon}
                      sx={{
                        background: "#ECF6FF",
                        "& .MuiSelect-select": {
                          minHeight: "20px",
                          padding: "11px 14px",
                          color: "lightSecondary.main",
                          fontWeight: "600",
                          fontSize: "0.9rem",
                        },
                        "& .MuiSelect-icon": {
                          color: "lightSecondary.main",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Tech
                      </MenuItem>
                      <MenuItem value={"AI"}>AI</MenuItem>
                      <MenuItem value={"Blockchain"}>Blockchain</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: "50%",
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                        width: "100%",
                        textTransform: "inherit",
                        p: "7px 15px",
                      }}
                      onClick={handleFilterClear}
                    >
                      Clear
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      width: "50%",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        width: "100%",
                        textTransform: "inherit",
                        p: "7px 15px",
                        boxShadow: "none",
                      }}
                      onClick={handleFilter}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
              </Menu> */}
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid mt={0.5} container rowSpacing={2} columnSpacing={2} sx={{marginBottom:"20px"}}>
        {boardData && boardData?.solutions && boardData?.solutions.length > 0 ? (
          boardData?.solutions.map((board, index) => (
            <Grid
              item
              xs={12}
              md={isDrawerOpen ? 12 : 6} // Change the size when drawer is open
              lg={isDrawerOpen ? 6 : 6} // Change the size when drawer is open
              key={board._id}
            >
              {/* new card */}
              <Card
              sx={{
                boxShadow: 'none',
                borderRadius: "10px",
                cursor:"pointer"
              }}
              onClick={() => handleCardClick(board._id, board.solution_name)}
            >
              <CardContent
                sx={{
                  p: 0,
                  [theme.breakpoints.down('sm')]: {
                    position: 'relative'
                  }
                }}
                style={{
                  paddingBottom: "0"
                }}
              >
                <Box
                  sx={{
                    // px: 2,
                    // py: 2,
                    [theme.breakpoints.down('md')]: {
                      py: 3,
                    }
                  }}
                >
                  <Stack
                    direction="row"
                    sx={{
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      maxWidth:'100%',
                      mb:2,
                      px: 2,
                      py:2,
                      minHeight: '100px',
                      [theme.breakpoints.down('sm')]: {
                        display: 'block'
                      }
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{
                        alignItems: "center",
                        maxWidth:'100%',
                        [theme.breakpoints.down('sm')]: {
                          display: 'block'
                        }
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: '150px',
                          maxWidth:'150px',
                          height:"44px",
                          pr: 2,
                          '& img': {
                            [theme.breakpoints.down('sm')]: {
                              width: 'auto !important',
                              maxWidth: '100%',
                              maxHeight: '50px'
                            }
                          }
                        }}
                      >
                        {board?.logo ?
                          <img 
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            mixBlendMode: "multiply",
                          }}
                        src={
                          s3Url +
                          board?.logo
                        }
                        alt={board?.solution_name}
                        />
                        :
                        <Avatar
                        sx={{
                          color: "#fff",
                          bgcolor: "lightSecondary.main",
                          width: "50px",
                          height: "50px",
                        }}
                        alt={board?.solution_name}
                      >
                        {getInitials(board?.solution_name)}
                      </Avatar>
                        }
                      </Box>
                      <Box
                      sx={{
                        width:'100%',
                        height:"44px",
                        [theme.breakpoints.down('lg')]: {
                          height:"85px",
                        },
                        [theme.breakpoints.down('md')]: {
                          height:"44spx",
                        }
                      }}
                      >
                        <Typography noWrap variant="h6" color="textSecondary"
                          sx={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "secondary.main",
                            mb: 0,
                            maxWidth:'100%',
                            [theme.breakpoints.down('lg')]: {
                              maxWidth:'150px',
                            },
                            [theme.breakpoints.down('md')]: {
                              maxWidth:'100%',
                            },
                          }}
                        >
                         {board?.solution_name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary"
                          sx={{
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            color: "secondary.main",
                            width:'100%',
                            maxHeight:"100%",
                            [theme.breakpoints.down('lg')]: {
                               minHeight: '34px',
                               maxHeight:"44px",
                            },
                            [theme.breakpoints.down('sm')]: {
                              minHeight: 'inherit'
                            }
                          }}
                        >
                          {/* {board?.solution_name}:  */}
                          <Tooltip title={board?.short_overview}>
                            {truncateText(board?.short_overview)}
                          </Tooltip>
                        </Typography>
                      </Box>
                    </Stack>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        alignSelf: 'start',
                        [theme.breakpoints.down('sm')]: {
                          position: 'absolute',
                          top: '15px',
                          right: '10px'
                        }
                      }}
                    >
                      <Link to={board?.source_link} target="blank">
                      <IconButton
                        sx={{
                          p: 0.5,
                        }}
                        onClick={(event) => {
                          event.stopPropagation();  // Prevent card click event
                        }}
                        >
                        <OpenInNewOutlinedIcon sx={{ color: 'lightSecondary.main' }}/>
                      </IconButton>
                      </Link>
                    </Box>
                  </Stack>
                  <Box
                      sx={{
                        py: 2,
                        px: 2,
                        mt:2,
                        width: "100%",
                        backgroundColor: "rgba(219, 235, 248, 0.2)",
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "space-between",
                        borderTop: "solid 1px rgba(162, 194, 241, 1)",
                        // minHeight: '102px',
                        [theme.breakpoints.down("md")]: {
                          flexWrap: "wrap",
                          px: 2,
                        },
                      }}
                    >      
                      <Box
                      sx={{
                        display:'flex',
                        gap:0.5,
                        alignItems:'center'
                      }}
                      >
                        <Typography
                        sx={{
                          fontWeight:'600',
                          color: "secondary.main",
                        }}
                        >
                          New Requirement : 
                        </Typography>
                        <Typography
                        sx={{
                          fontSize: "0.9rem",
                            fontWeight: "500",
                            color: "secondary.main",
                        }}
                        >
                        {board.newRequirementCount}
                        </Typography>
                        </Box>
                        <Box
                      sx={{
                        display:'flex',
                        gap:0.5,
                        alignItems:'center'
                      }}
                      >
                        <Typography
                        sx={{
                          fontWeight:'600',
                          color: "secondary.main",
                        }}
                        >
                          In-Progress Requirement : 
                        </Typography>
                        <Typography
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "secondary.main",
                        }}
                        >
                        {board.inProgressRequirementCount}
                        </Typography>
                        </Box>
                  {/* </Box> */}
                  </Box>
                </Box>
              </CardContent>
            </Card>
              {/* </Link> */}
            </Grid>
          ))
        ) : (
          boardData && boardData?.length == 0 ?
          (
            <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
              width: "100%",
            }}
          >
            <NoSolutionScreen />
          </Box>
          ):
          (
            <Grid container spacing={2} sx={{ py: 2, px: 1 }}>
                {[...Array(skullCount)].map((_, index) => (
                   <BsiCoLabSkull/>
              ))}
           </Grid>
          
          )
         
        )}
      </Grid>
      {/* <Outlet/> */}
      <Modals
        open={openBoardSettings}
        handleClose={closeBoardSettings}
        modalWidth={500}
      >
        <BoardSetting
          handleClose={closeBoardSettings}
          deleteBoardAlertHandle={deleteBoardAlertHandle}
          showToastMessage={showToastMessage}
          currentBoardId={boardId}
          boardName={boardName}
          refetchBsiCoLab={refetch}
        />
      </Modals>
      <Modals
        open={openDeleteBoardAlert}
        handleClose={closeDeleteBoardAlert}
        modalWidth={500}
        boardId={boardId}
        boardName={boardName}
      >
        <DeleteBoardAlert
          handleClose={closeDeleteBoardAlert}
          goBackFromAlertHandle={goBackFromAlertHandle}
          showToastMessage={showToastMessage}
          refetch={refetch}
          currentBoardId={boardId}
        />
      </Modals>
      <Modals
        open={openUpgradeModal}
        handleClose={handleCloseUpgradeModal}
        modalWidth={400}
      >
        <LimitExceededModal
          limitMessage={limitMessage}
          handleClose={handleCloseUpgradeModal}
          showToastMessage={showToastMessage}
          setOpenSubscribeModal ={setOpenSubscribeModal}
        />
      </Modals>
      {/* Subscribe Modal */}
      <UpgradeModal
        open={openSubscribeModal}
        handleClose={handleCloseSubscribeModal}
        modalWidth={650}
      >
        <SubscribeModal
          limitMessage={limitMessage}
          handleClose={handleCloseSubscribeModal}
          setOpenPaymentSuccess={setOpenPaymentSuccess}
          showToastMessage={showToastMessage}
        />
      </UpgradeModal>
      <Modals
        open={openPaymentSuccess}
        handleClose={handleClosePaymentSuccessModal}
        modalWidth={450}
      >
        <PaymentSuccess
          handleClose={handleClosePaymentSuccessModal}
        />
      </Modals>
    </>
  );
};

export default SolutionProviderBsiCoLab;
